module.exports = __webpack_public_path__ + "static/media/water.3ddca3d6.gif";